import React, { useState } from "react"
import  "./Modal.css";

const OkModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">{props.headerTitle}</span>
    </div>
    <div className="p-4 text-center">
<p>
     {props.message}
</p>
<p>
</p>
<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-12 text-center">
    <button className="btn btn-danger btn-block" onClick={props.ok}>{props.btnTitle}</button>
    </div>
     
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default OkModal;